var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/welcome3.209b9b59.png","uri@3x": __webpack_public_path__ + "static/media/welcome3.b6a1fe94.png","uri@2x": __webpack_public_path__ + "static/media/welcome3.216be224.png",
    width: 179,
    height: 178
});